import { BarceloComponent } from "components-utils";

const AllHotel = {
  bwdExperienceBanner: BarceloComponent({
    selector: ".bwd-experience-banner, .bwd-experience-banner-dl-id",
    path: "bwd/hotel/bwd-experience-banner/js/bwd-experience-banner",
  }),

  bwdServiceCard: BarceloComponent({
    selector: ".bwd-service-card, .bwd-service-card-dl-id",
    path: "bwd/hotel/bwd-service-card/js/bwd-service-card",
  }),

  bwdServicesList: BarceloComponent({
    selector: ".bwd-services-list, .bwd-services-list-dl-id",
    path: "bwd/hotel/bwd-services-list/js/bwd-services-list",
  }),

  bwdTripadvisorReviews: BarceloComponent({
    selector: ".bwd-tripadvisor-reviews, .bwd-tripadvisor-reviews-dl-id",
    path: "bwd/hotel/bwd-tripadvisor-reviews/js/bwd-tripadvisor-reviews",
  }),

  bwdWeather: BarceloComponent({
    selector: ".bwd-weather, .bwd-weather-dl-id",
    path: "bwd/hotel/bwd-weather/js/bwd-weather",
  }),

  bwdWeddingCalendar: BarceloComponent({
    selector: ".bwd-wedding-calendar, .bwd-wedding-calendar-dl-id",
    path: "bwd/hotel/bwd-wedding-calendar/js/bwd-wedding-calendar",
  }),
};

export default AllHotel;
